import React, { useContext } from 'react';
import { JobContext } from '../JobContext';
var jobMap = {
  'job-of-the-week': 'Job_of_the_Week',
  'featured-job': 'Featured_Job',
  'featured-employer': 'Featured_Employer',
  'sponsored-job': 'Sponsored_Job',
  'silver-sponsored-job': 'Silver_Sponsored_Job'
};
export var JobLink = function JobLink(_ref) {
  var reference = _ref.reference,
      children = _ref.children;

  var _useContext = useContext(JobContext),
      promoId = _useContext.promoId,
      jobPageCanonicalUrl = _useContext.jobPageCanonicalUrl,
      target = _useContext.target,
      cardStyle = _useContext.cardStyle;

  var dataModule = jobMap[cardStyle] || cardStyle;
  return /*#__PURE__*/React.createElement("a", {
    ref: reference,
    href: jobPageCanonicalUrl,
    target: target,
    "data-testid": "job-card-link",
    "data-mz": true,
    "data-id": promoId,
    "data-module": dataModule,
    "data-position": "job-card"
  }, children);
};
JobLink.displayName = "JobLink";